import axios, { buildApi } from '@/libs/api.request';
let name = '/warehouse/tow'

export const apis = buildApi({
  get: [name + '/index&list', name + '/log/:id&log'],
  post: [name + '/update']
})